window.chartVermoegensstruktur = {
	data: {
		kategorie: [],
	},

	showLoading() {
		this.chart.showLoading()
	},

	hideLoading() {
		this.chart.hideLoading()
	},

	init() {
		this.chart = new Highcharts.Chart("chart_vermoegensstruktur", {
			chart: {
				type: "pie",
				events: {
					render: function () {
						var chart = this,
							series = chart.series,
							allZeros = true
						for (var i = 0; i < series[0].data.length; i++) {
							if (series[0].data[i].y !== 0) {
								allZeros = false
							}
						}
						if (allZeros) {
							chart.showLoading("Keine Daten vorhanden")
						} else {
							chart.hideLoading()
						}
					},
				},
			},

			tooltip: {
				headerFormat: "",
				pointFormatter: function () {
					return `${this.name}<br/><b>${Highcharts.numberFormat(this.percentage, 0)}%</b>`
				},
				style: {
					fontSize: chartFontSizeMittel,
					textAlign: "center",
				},
			},

			plotOptions: {
				series: {
					animation: {
						duration: 1200,
						easing: "easeInOut",
					},
					animationLimit: Infinity,
				},
			},

			series: this.seriesStruktur(),
		})
	},

	update() {
		if (!this.chart) return

		// this.chart.showLoading()

		const seriesArrays = [this.seriesStruktur(), this.seriesKategorie()]
		const alleSeries = [].concat(...seriesArrays)

		alleSeries.forEach((serie) => {
			const s = this.chart.get(serie.id)
			if (s) s.setData(serie.data, false)
		})

		// this.chart.redraw({ duration: chartAnimationDuration })
		this.chart.redraw({ duration: 1200 })
		this.chart.hideLoading()
	},

	updateSeriesData(seriesData) {
		// Alle Series entfernen
		while (this.chart.series.length > 0) {
			this.chart.series[0].remove(false)
		}

		// Series hinzufügen
		seriesData.forEach((serie) => {
			this.chart.addSeries(serie, false)
		})

		this.chart.redraw({ duration: 1200 })
	},

	seriesStruktur() {
		const data = []
		const vermoegensgruppen = document.querySelectorAll("[data-vermoegensgruppe-bezeichnung]")

		vermoegensgruppen.forEach((vermoegensgruppe) => {
			const farbe = getGradientColor(vermoegensgruppe.dataset.farbe)
			const bezeichnung = vermoegensgruppe.dataset.vermoegensgruppeBezeichnung
			const divVermoegenswerts = vermoegensgruppe.querySelector("details")
			const vermoegenswerts = Array.from(vermoegensgruppe.querySelectorAll("[data-bezeichnung]"))

			if (bezeichnung === "Liquidität" || !divVermoegenswerts.open) {
				let betrag = 0
				if (bezeichnung === "Liquidität") {
					const stringBetrag = vermoegensgruppe.querySelector("#vermoegensstruktur_liquiditaet")?.innerHTML
					const floatBetrag = currencyStringToFloat(stringBetrag)
					betrag = parseInt(floatBetrag)
				} else {
					betrag = vermoegenswerts.reduce((summe, vermoegenswert) => summe + parseInt(vermoegenswert.dataset.betrag), 0)
				}

				data.push({
					name: bezeichnung,
					color: farbe,
					y: betrag,
				})
			} else {
				vermoegenswerts.forEach((vermoegenswert) => {
					const bezeichnung = vermoegenswert.dataset.bezeichnung
					const betrag = parseInt(vermoegenswert.dataset.betrag)

					data.push({
						name: bezeichnung,
						color: farbe,
						y: betrag,
					})
				})
			}
		})

		return (series = [
			{
				id: "bruttovermoegenswerte",
				data: data,
			},
		])
	},

	seriesKategorie() {
		return [
			{
				id: "anlagekategorien",
				data: this.data.kategorie,
			},
		]
	},
}
